import axios from "axios";

export default class XvidApi {
    constructor(domain) {
        this.baseUrl = `https://${domain}/api/v1`;
        this._api = axios.create({
            baseURL: `${this.baseUrl}/extendedauth/`,
            headers: {
                'content-type': 'application/json',
            },
            withCredentials: true,
        });

        this._isApiCalled = false;
        this._sessionId = null;
    }

    async canAccess(urls) {
        urls = urls.filter(url => url.indexOf('autograph_tag=') !== -1);
        if (!urls.length) {
            return true;
        }

        if (this._isApiCalled) {
            return true;
        }
        this._isApiCalled = true;

        const response = await this._api.post('', {urls});

        if (!response.data.hasOwnProperty('extendedauth')) {
            return true;
        }

        const info = response.data.extendedauth;
        if (info.status !== 'PENDING') {
            return true;
        }

        this._sessionId = info.id;

        return info;
    }

    async resend() {
        if (!this._sessionId) {
            throw new Error('Missing session id. Please refresh the page and try again.');
        }

        const response = await this.handleApiError(() => this._api.put(this._sessionId, {code: null, email_status: 'RESEND'}));

        if (!(response.data.hasOwnProperty('extendedauth') && response.data.extendedauth.hasOwnProperty('message'))) {
            throw new Error('There was an issue resending the code. Please try again');
        }

        return response.data.extendedauth.message;
    }

    async verify(code) {
        if (!this._sessionId) {
            throw new Error('Missing session id. Please refresh the page and try again.');
        }

        if (!code) {
            throw new Error('Please enter the verification code.');
        }

        const response = await this.handleApiError(() => this._api.put(this._sessionId, {code}));

        if (!(response.data.hasOwnProperty('extendedauth') && response.data.extendedauth.hasOwnProperty('status'))) {
            throw new Error('There was an issue verifying the code. Please try again');
        }

        if (response.data.extendedauth.status !== 'SUCCESS') {
            throw new Error('The code could not be validated. Please refresh the page and try again.');
        }
    }

    async handleApiError(callback) {
        try {
            return await callback();
        } catch (err) {
            if (err.response) {
                throw new Error((err.response.data.error && err.response.data.error.error_message) || 'An unknown error has occurred. Please try again.');
            }
            throw err;
        }
    }
}
